//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import * as Actions from './actions';
import { logToSentry } from "utils/networkErrorUtils";

//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- Create log ----------------
export const handleListPlacementexam = () => async (dispatch) => {
	try {
		const data = await apis.get('activitiesRDS', `/placementExamList`)
		if(data&&data.success){
			dispatch(Actions.setPlacenetExamList(data.data))
		}
		return data;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'listing placement exam',
                error,
                module: 'PLACEMENT_EXAM',
                operation: 'LIST_PLACEMENT_EXAM'
            });
		}
	}
	return {}
};
export const handleListPlacementexamForDistrict = (orgId) => async (dispatch) => {
	try {
		const data = await apis.get('activitiesRDS', `/placementExamByOrg/${orgId}`)
		if(data&&data.success){
			dispatch(Actions.setPlacenetExamList(data.data))
		}
		return data;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'listing placement exam for district',
                error,
                module: 'PLACEMENT_EXAM',
                operation: 'LIST_PLACEMENT_EXAM_FEEDBACK_DATA'
            });
		}
	}
	return {}
};
const PAGE_SIZE = 50;

export const handleListPlacementexamSubmissionsByCode = (code, limit = PAGE_SIZE, offset = 0, skipDispatch = false) => async (dispatch) => {
	try {
		const data = await apis.get('activitiesRDS', `/listPlasementExamSubmissionByExamCode/${code}?limit=${limit}&offset=${offset}`);
		if (!data || !data.success) {
			return { success: false, data: [] };
		}
		const rows = data.data || [];
		if (!skipDispatch) {
			dispatch(Actions.setPlacementExamSubmissionsByCode({
				assignment_code: code,
				submissions: rows
			}));
		}
		return { success: true, data: rows };
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
				message: 'listing placement exam submissions by code',
				error,
				module: 'PLACEMENT_EXAM',
				operation: 'LIST_PLACEMENT_EXAM_STUDENT_BOOK_CLASS'
			});
		}
	}
	return {};
};

export const handleListPlacementexamSubmissionsByCodeFiltered = (code, limit, offset, filters = {}, skipDispatch = false) => async (dispatch) => {
	try {
		const body = {
			exam_code: code,
			limit,
			offset,
			searchByName: filters.searchByName || '',
			searchBySchool: filters.searchBySchool || '',
			searchByStudentId: filters.searchByStudentId || '',
			session: filters.session || '',
			status: filters.status || 'All',
			gradeMin: filters.gradeMin != null ? filters.gradeMin : undefined,
			gradeMax: filters.gradeMax != null ? filters.gradeMax : undefined,
			proficiency: filters.proficiency && filters.proficiency !== 'All' ? filters.proficiency : '',
			nativeNonNative:
				filters.nativeNonNative && filters.nativeNonNative !== 'All' ? filters.nativeNonNative : '',
			max_grade: filters.max_grade != null && !Number.isNaN(Number(filters.max_grade)) ? Number(filters.max_grade) : undefined,
			grade: filters.grade != null && !Number.isNaN(Number(filters.grade)) ? Number(filters.grade) : undefined,
		};
		const data = await apis.post('activitiesRDS', '/listPlasementExamSubmissionByExamCodeFiltered', { body });
		if (!data || !data.success) {
			return { success: false, data: [], total: 0 };
		}
		const payload = data.data || {};
		const rows = Array.isArray(payload.data) ? payload.data : [];
		const total = Number(payload.total) || 0;
		const grade = payload.grade || [];
		if (!skipDispatch) {
			dispatch(Actions.setPlacementExamSubmissionsByCode({
				assignment_code: code,
				submissions: rows
			}));
		}
		return { success: true, data: rows, total, grade };
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
				message: 'listing placement exam submissions by code (filtered)',
				error,
				module: 'PLACEMENT_EXAM',
				operation: 'LIST_PLACEMENT_EXAM_STUDENT_BOOK_CLASS'
			});
		}
	}
	return {};
};

export const handleGetAllSubmissionRow = (code) => async (dispatch) => {
	try {
		const data = await apis.post('activitiesRDS', '/getAllSubmissionRow', { body: { exam_code: code } });
		return data;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
				message: 'getting all submission row',
				error,
				module: 'PLACEMENT_EXAM',
				operation: 'GET_ALL_SUBMISSION_ROW'
			});
		}
		return {}
	}
};

export const handleCreatePlacementExam = (data) => async (dispatch) => {
	try {
		const created_data = await apis.post('activitiesRDS', `/placementExamCreate`,{
			body:data
		})
		if (created_data&&created_data.success) {
			await dispatch(Actions.updatePlacementExamList(created_data.data));
		}
		return created_data;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'creating placement exam',
                error,
                module: 'PLACEMENT_EXAM',
                operation: 'CREATE_PLACEMENT_EXAM'
            });
		}
		return {}
	}
};
export const handleUpdatePlacementExam = (data) => async (dispatch) => {
	try {
		const updated_data = await apis.post('activitiesRDS', `/updatePlacementExam`,{
			body:data
		})
		if (updated_data&&updated_data.success) {
			await dispatch(Actions.updatePlacementExamList(updated_data.data));
		}
		return updated_data;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'updating placement exam',
                error,
                module: 'PLACEMENT_EXAM',
                operation: 'UPDATE_PLACEMENT_EXAM'
            });
		}
		return {}
	}
};

export const handleDuplicatePlacementExam = (data) => async (dispatch) => {
	try {
		const duplicated_data = await apis.post('activitiesRDS', `/duplicatePlacementExam`,{
			body:data
		})
		if (duplicated_data&&duplicated_data.success) {
			await dispatch(Actions.updatePlacementExamList(duplicated_data.data));
		}
		return duplicated_data;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'duplicating placement exam',
                error,
                module: 'PLACEMENT_EXAM',
                operation: 'DUPLICATE_PLACEMENT_EXAM'
            });
		}
		return {}
	}
};

export const handleDeletePlacementExam = (id) => async (dispatch) => {
	try {
		const deleted_data = await apis.del('activitiesRDS', `/deletePlacementExam/${id}`)
		if (deleted_data&&deleted_data.success) {
			await dispatch(handleListPlacementexam());
		}
		return deleted_data;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'deleting placement exam',
                error,
                module: 'PLACEMENT_EXAM',
                operation: 'DELETE_PLACEMENT_EXAM'
            });
		}
		return {}
	}
};
//TODO: need to handle





export const handleGetPlacementExamAssignedStatus = (exam_code) => async (dispatch) => {
	try {
		const created_data = await apis.post('activitiesRDS', `/getPlacementExamByCode`,{
			body:{
				exam_code
			}
		})
		if(created_data&&created_data.success){
			if(created_data.status_code=="200"){
				dispatch(Actions.setPlacementExamSession({
					key: 'exam_info',
					value: created_data.data
				}))
			}else if(created_data.status_code == '205'){
				dispatch(Actions.setPlacementResumeExamSession(created_data.data))
			}
		}
		return created_data;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'getting placement exam assigned status',
                error,
                module: 'PLACEMENT_EXAM',
                operation: 'GET_PLACEMENT_EXAM_ACTIVITY_STUDENT'
            });
		}
	}
};
export const handleAssignToDistrict = (district_id,exam_id) => async (dispatch) => {
	try {
		const created_data = await apis.post('activitiesRDS', `/assignPlacementExamToDist`,{
			body:{
				district_id,
				exam_id
			}
		})
		if(created_data&&created_data.success){
			await Promise.all([
				dispatch(handleListDistrictplacemetExamByExamId(exam_id)),
				dispatch(handleListPlacementexam())
			])
		}
		return created_data;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'assigning placement exam to district',
                error,
                module: 'PLACEMENT_EXAM',
                operation: 'ADD_PLACEMENT_EXAM_TEACHER_DATA'
            });
		}
		return {}
	}
};
export const handleConfigurePlacementExamDistrictInfo = (district_id,data) => async (dispatch) => {
	try {
		const created_data = await apis.post('activitiesRDS', `/config_placement_exam_districtinfo`,{
			body:{
				district_id,
				data
			}
		})
		if(created_data&&created_data.success){
			
		}
		return created_data;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'configuring placement exam district info',
                error,
                module: 'PLACEMENT_EXAM',
                operation: 'CREATE_PLACEMENT_EXAM_DISTRICT_INFO'
            });
		}
		return {}
	}
};
export const handleConfigureExamPlacementExamByOrg = (district_id,data) => async (dispatch) => {
	try {
		const created_data = await apis.post('activitiesRDS', `/config_placement_exam_for_org`,{
			body:{
				district_id,
				data
			}
		})
		if(created_data&&created_data.success){
			
		}
		return created_data;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'Error in operation',
                error,
                module: 'PLACEMENT_EXAM',
                operation: 'LIST_PLACEMENTEXAM'
            })
		}
		return {}
	}
};
export const handleDeactivateAssignToDistrict = (id,status, exam_id) => async (dispatch) => {
	try {
		const created_data = await apis.put('activitiesRDS', `/changeStatusPlacementExamAssignment`,{
			body:{
				id,
				status,
				exam_id
			}
		})
		if(created_data&&created_data.success){
			await Promise.all([
				dispatch(handleListDistrictplacemetExamByExamId(exam_id))
			])
		}
		return created_data;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'deactivating assign to district',
                error,
                module: 'PLACEMENT_EXAM',
                operation: 'DELETE_ACTIVITY_TEACHER_DATA'
            });
		}
		return {}
	}
};
export const handleListDistrictplacemetExamByExamId = (exam_code) => async (dispatch) => {
	try {
		const created_data = await apis.post('activitiesRDS', `/getPlacementOrgByExam`,{
			body:{
				exam_code
			}
		})
		if(created_data&&created_data.success){
           await dispatch(Actions.setPlacementExamDistrictAssignment({exam_id:exam_code,assign:created_data.data}))
		}
		return created_data;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'listing district placement exam by exam id',
                error,
                module: 'PLACEMENT_EXAM',
                operation: 'LIST_DEBATE_PLACEMENT_EXAM_BOOK_EXAM_INSTRUCTION'
            });
		}
		return {}
	}
};

export const handleCreatePlacementExamSession = (data,start_video_url) => async dispatch => {
	try {
		const created_data = await apis.post('activitiesRDS', `/createPlacementExamSession`, {
			body: data
		})
		if (created_data && created_data.success) {
			await dispatch(Actions.updatePlacementExamSession({
				key: 'session_info',
				value: created_data.data
			}))
			await dispatch(Actions.updatePlacementExamSession({
				key: 'start_video_url',
				value: start_video_url
			}))
		}
		return created_data;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'creating placement exam session',
                error,
                module: 'PLACEMENT_EXAM',
                operation: 'CREATE_PLACEMENT_EXAM_STUDENT'
            });
		}
		console.error(error,"error in creating session",error.message)
		return {}
	}

}
export const handleUpdatePlacementExamSessionLocal = (key,value) => async dispatch => {
	dispatch(Actions.updatePlacementExamSession({ key, value }))
}

export const handleUpdatePlacementExamSession = (key,value,id,step) => async dispatch =>{
	try {
		const created_data = await apis.put('activitiesRDS', `/updatePlacementExamSession`,{
			body:{
				key,
				value,
				id,
				step
			}
		})
		if (created_data && created_data.success) {
			await dispatch(Actions.updatePlacementExamSession({
				key: 'session_info',
				value: created_data.data
			}))
		}
		return created_data;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'updating placement exam session',
                error,
                module: 'PLACEMENT_EXAM',
                operation: 'UPDATE_PLACEMENT_EXAM_STUDENT'
            });
		}
		return {}
	}

}
export const handleUpdatePlacementExamSessionState = (key,value) => async dispatch =>{
	await dispatch(Actions.updatePlacementExamSession({
		key: key,
		value: value
	}))
}
export const handleClearPlacementSession= () => async dispatch =>{
	await dispatch(Actions.clearPlacementExmaSession())
}


export const handleCreatePlacementExamSubmissions = (data) => async dispatch => {
	try {
		const created_data = await apis.post('activitiesRDS', `/createPlacementExamSubmission`, {
			body: data
		})
		if (created_data && created_data.success) {
			await dispatch(Actions.updatePlacementExamSession({
				key: 'submission',
				value: created_data.data
			}))
		}
		return created_data;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'creating placement exam submissions',
                error,
                module: 'PLACEMENT_EXAM',
                operation: 'CREATE_PLACEMENT_EXAM_STUDENT'
            });
		}
		console.error(error,"error in creating session",error.message)
		return {}
	}

}
export const handleUpdatePlacementExamSubmissions = (data) => async dispatch => {
	try {
		const created_data = await apis.put('activitiesRDS', `/updatePlacementExamSubmissions`, {
			body: data
		})
		if (created_data && created_data.success) {
			await dispatch(Actions.updatePlacementExamSession({
				key: 'submission',
				value: created_data.data
			}))
		}
		return created_data;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'updating placement exam submissions',
                error,
                module: 'PLACEMENT_EXAM',
                operation: 'UPDATE_PLACEMENT_EXAM_STUDENT'
            });
		}
		console.error(error,"error in creating session",error.message)
		return {}
	}

}
export const handleReactivatePlacementExamSubmission = (id) => async () => {
	try {
		const created_data = await apis.put('activitiesRDS', `/reactivatePlacementExamSubmission`, {
			body: { id }
		})
		return created_data;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'reactivating placement exam submission',
                error,
                module: 'PLACEMENT_EXAM',
                operation: 'REACTIVATE_PLACEMENT_EXAM_SUBMISSION'
            });
		}
		console.error(error, "error in reactivating placement exam submission", error.message)
		return {}
	}
}
export const handlePlacementExamAiGrading = async (submission_id) => {
	try {
		const created_data = await apis.post('activitiesRDS', `/scheulePlacementAiGrading`, {
			body: {
				submission_id
			}
		})
		return created_data;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'scheduling placement exam ai grading',
                error,
                module: 'PLACEMENT_EXAM',
                operation: 'SET_PLACEMENT_EXAM_ACTIVITY_GROUP'
            });
		}
		console.error(error, "error in creating session", error.message)
		return {}
	}

}
export const handlePlacementExamAiReGrading = async (submission_id) => {
	try {
		const created_data = await apis.post('activitiesRDS', `/ai_grading_placement_exam`, {
			body: {
				submission_id,
				force: true
			}
		})
		return created_data;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'forcing placement exam ai regrading',
                error,
                module: 'PLACEMENT_EXAM',
                operation: 'SET_PLACEMENT_EXAM_ACTIVITY_GROUP'
            });
		}
		console.error(error, "error in forcing ai grading", error.message)
		return {}
	}

}
export const handleLogPlacementBug = async (meta_data) => {
	try {
		const created_data = await apis.post('activitiesRDS', `/placement/report_placement_bug`, {
			body: meta_data
		})
		return created_data;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'logging placement bug',
                error,
                module: 'PLACEMENT_EXAM',
                operation: 'LIST_PLACEMENT_BOOK'
            });
		}
		console.error(error, "error in creating session", error.message)
		return {}
	}

}
export const handleGetOverallAverage = async (exam_code) => {
	try {
		const created_data = await apis.post('activitiesRDS', `/get_overall_placement_result`, {
			body: {
				exam_code
			}
		})
		return created_data;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'getting overall average',
                error,
                module: 'PLACEMENT_EXAM',
                operation: 'GET_ORGANIZATION_ACTIVITY'
            });
		}
		console.error(error, "error in creating session", error.message)
		return {}
	}

}

export const handleGetPlacementOrgConfig = (org_id) => async dispatch => {
	try {
		const created_data = await apis.get('activitiesRDS', `/get_placement_exam_org_config/${org_id}`)
		if (created_data && created_data.success) {
			await dispatch(Actions.setPlacememntOrgConfig(created_data.data))
		}
		return created_data;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'getting placement org config',
                error,
                module: 'PLACEMENT_EXAM',
                operation: 'GET_PLACEMENT_ORGANIZATION_CLASS'
            });
		}
		console.error(error,"error in creating session",error.message)
		return {}
	}

}

export const handlePlacementOverallReport = (org_id, exam_code) => async dispatch => {
	try {
		const created_data = await apis.post('activitiesRDS', `/placementOverallReport`, {
			body: {
				orgId: org_id,
				exam_code: exam_code
			}
		})
		return created_data;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'getting placement org config',
                error,
                module: 'PLACEMENT_EXAM',
                operation: 'GET_PLACEMENT_ORGANIZATION_CLASS'
            });
		}
		return {}
	}
}

export const handleReportByYear = (org_id, exam_code) => async dispatch => {
	try {
		const created_data = await apis.post('activitiesRDS', `/placementYearOverYearReport`, {
			body: {
				orgId: org_id,
				exam_code: exam_code
			}
		})
		return created_data;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'getting placement org config',
                error,
                module: 'PLACEMENT_EXAM',
                operation: 'GET_PLACEMENT_ORGANIZATION_CLASS'
            });
		}
		return {}
	}
}